import { dataRocketSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconRocketSolid = /*#__PURE__*/createIcon(dataRocketSolid)
export default IconRocketSolid
